import * as React from 'react'
import { Tooltip } from 'reactstrap';
import './styles.css'
import * as Utils from './utils'

interface Props {
  id: string,
  helpType: string,
}
interface State {
  isOpen: boolean,
}

export class Help extends React.Component<any, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      isOpen: false,
    }
  }

  // Generally do not want to use setState method, use redux for state management
  public toggle = () => this.setState({isOpen: !this.state.isOpen})

  public render() {
    const tooltipTargetId = 'Tooltip-' + this.id()
    return this.helpExists() &&
      <span className="rasa-help">
        <i className={`fa fa-question-circle ${this.helpOption().fontSize || 'icon-12'}`}
          aria-hidden="true"
          id={tooltipTargetId}></i>
        <Tooltip placement="top"
                className="rasa-tooltip"
                isOpen={this.state.isOpen}
                target={tooltipTargetId}
                toggle={this.toggle}>
          <span dangerouslySetInnerHTML={{__html: this.helpOption().description}}/>
        </Tooltip>
      </span>
  }

  private helpOption() {
    return Utils.helpOption(this.props.helpType)
  }

  private helpExists() {
    return Utils.helpExists(this.props.helpType)
  }

  private id() {
    return this.props.id.replace(/[ #]/g, '').toLowerCase()
  }
}



// WEBPACK FOOTER //
// ./src/components/help/component.tsx